import React from 'react'
import _ from 'lodash'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { Icon } from 'camino-react'

const TicketSelector = ({
  tickets, value, setValue, onDelete, sortMethod
}) => {
  const options = _.map(tickets, (title, id) => (
    { value: id, label: `${id} - ${title}` }
  ))
  const sortedOptions = sortMethod(options)
  const selected = _.find(options, { value })

  return (
    <div className="flex items-start">
      <Select
        value={selected}
        onChange={(selectedValue) => { setValue((selectedValue || {}).value) }}
        options={sortedOptions}
        searchable
        className="flex--grow Select--no-bottom-margin"
      />

      <button
        className="text-3xl mt-3 mx-3 text-red-500 duration-300 hover:text-red-700"
        type="button"
        onClick={onDelete}
      >
        <Icon type="trash2" />
      </button>
    </div>
  )
}

TicketSelector.propTypes = {
  tickets: PropTypes.objectOf(PropTypes.string),
  value: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

TicketSelector.defaultProps = {
  tickets: {},
  value: null,
  sortMethod: tickets => tickets
}

export default TicketSelector
